import {useState, useContexttext, useContext, useEffect, use } from 'react';
import Filtres from '../vitrines/filtres/Filtres';
//import './mobile_navigation.css';
import { useNavigate } from 'react-router-dom';
import { Notifications } from './Notifications';
import { UserContext } from '../../AppContextProvider';
import settingsIcon from '../icons/settings.webp';
import chatIcon from '../icons/chat_mobile.webp';
import filtresIcons from '../icons/_filtres.webp';
import aboutIcon from '../icons/about.webp';
import colis_icon from './icons/colis_.webp';
import money_icon from './icons/money.webp';
import {QrCustomerTicket, QrPackageTicket, QrPaymentTicket} from '../utils/QR/QrCodeScan';
import QRScanner from '../utils/QR/QrCodeScan';
import { useFetch } from '../api/FetchApiData';
import { TabList } from 'react-tabs';
import ChatBot from '../chatbot/ChatBot';
import { FaWhatsapp } from "react-icons/fa";
import { Button } from 'react-chat-elements';
import scanner_icon from './icons/scan.webp';
import { AppContext } from '../../AppContextProvider';
import { isMobile } from 'react-device-detect';
import fr_icon from './icons/fr.webp';
import en_icon from './icons/uk.webp';
import ar_icon from './icons/ar.webp';
import km_icon from './icons/km.webp';
import kmf_icon from './icons/kmf.webp';
import euro_icon from './icons/euro.webp';
import lang_icon from './icons/lang.webp';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import CG from '../cgu/CG';

if (isMobile)
    import('./mobile_navigation.css').then(() => {});
else
    import('./navigation.css').then(() => {});


function ButtonConversations()
{
    /*
    const [UserState,setUserState] = useContext(UserContext);
    const [counter,setCounter] = useState(UserState.messages_counter);
    const [convUrl,setConvUrl] = useState('/conversations/');
    const navigator = useNavigate();
    const message_received = (data)=>{
        if(!!data.user_profile)
        {
            //setCounter(data['profile'].messages_counter);
            setUserState({...data.user_profile})
        }
    }
    
    useEffect(()=>{
        
        //WsNotifications.onMessage(message_received);
        if(UserState.is_staff)
        {
            let role = 'staff';
            setCounter(UserState.messages_counter);
            setConvUrl(`/conversations/${role}/all/`);
        }
        else
        {
            const rik_id = sessionStorage.getItem('rikinaze_id');
            setCounter(UserState.messages_counter);
            setConvUrl(`/conversation/${rik_id}/`);
        }

    },[UserState.auth])
    */
    return(
        <div className='btn-nav'>
            <FaWhatsapp onClick={() =>{window.open("https://wa.me/745200247", "_blank")}} size={40} style={{width:'100%'}} color="black" />
        </div>
    );
    }

function ButtonQrPayment({close=()=>{}})
{
    const [btnsState,setBtnsState] = useState({client:{selected:true,bgColor:'white'},partner:{selected:false,bgColor:'lightgray'},page: <QrCustomerTicket close={close} />})
    const [UserState,setUserState] = useContext(UserContext);
    

    const onClickPage = (target)=>{
            if(target==='Client')
                {setBtnsState({client:{selected:true,bgColor:'white'},
                    partner:{selected:false,bgColor:'lightgray'},
                    page:<QrCustomerTicket close={close} />
                    });
                }
            else if(target==='Partner')
                setBtnsState({client:{selected:false,bgColor:'lightgray'},partner:{selected:false,bgColor:'white'},page:<QrPaymentTicket close={close} />})

    }

    return(
    <div className="back-screen" style={{position:'fixed',top:'0px',left:'0px'}}>
        <div style={{width:'95%',backgroundColor:'white',position:'relative',top:'100px',margin:'auto',paddingTop:'10px'}}>
            {(UserState.is_staff) && <div style={{display:'block',width:'100%',justifyContent:'center'}}>
                <input className='Qr-ChangePage' onMouseOver={e=>{}} type='button' onClick={e=>{onClickPage("Client")}}  value={'Client'} style={{height:'35px',width:'45%',backgroundColor:btnsState.client.bgColor,border:'1px solid lightgray'}}  />
                <input className='Qr-ChangePage' type='button' onClick={e=>{onClickPage("Partner")}} value={'Partenaire'} style={{height:'35px',width:'45%',backgroundColor:btnsState.partner.bgColor,border:'1px solid lightgray'}} />
            </div>}
            {btnsState.page}
        </div>    
    </div>)
}

function ButtonQrPackage({close=()=>{}})
{
   return(
    <div className="back-screen" style={{position:'fixed',top:'0px',left:'0px'}}>
        <div style={{width:'95%',backgroundColor:'white',position:'relative',top:'100px',margin:'auto',paddingTop:'10px'}}>
            <QrPackageTicket close={close} />
        </div>
    </div>
   ) 
}

export function SettingsMenu({close=()=>{}})
{
    const [AppState,setAppState] = useContext(AppContext);
    const [lang,setLang] = useState(AppState.settings.lang);
    const [dev,setDev] = useState(AppState.settings.devise);
    const navigator = useNavigate();
    const fetData = useFetch();
    const { t,i18n } = useTranslation();
    const options = {
        lang:[
            {value:'fr',label:<div style={{fontSize:'small',height:'20px'}}><img style={{width:'20px',paddingRight:'5px',verticalAlign:'middle'}} src={fr_icon} alt="Français" /> <label style={{verticalAlign:'middle'}}>Français</label></div>},
            {value:'en',label:<div style={{fontSize:'small',height:'20px'}}><img style={{width:'20px',paddingRight:'5px',verticalAlign:'middle'}} src={en_icon} alt="English" /> <label style={{verticalAlign:'middle'}}>English</label></div>},
            {value:'ar',label:<div style={{fontSize:'small',height:'20px'}}><img style={{width:'20px',paddingRight:'5px',verticalAlign:'middle'}} src={ar_icon} alt="العربية" /> <label style={{verticalAlign:'middle'}}>العربية </label></div>},
            {value:'km',label:<div style={{fontSize:'small',height:'20px'}}><img style={{width:'20px',paddingRight:'5px',verticalAlign:'middle'}} src={km_icon} alt="English" /> <label style={{verticalAlign:'middle'}}>Comorien</label></div>},
        ],
        devise:[
            {value:'euro',label:<div style={{fontSize:'small',height:'20px'}}><img style={{width:'15px',paddingRight:'5px',verticalAlign:'middle'}} src={euro_icon} alt="EURO" /><label style={{verticalAlign:'middle'}}>EURO</label></div>},
            {value:'kmf',label:<div style={{fontSize:'small',height:'20px'}}><img style={{width:'15px',paddingRight:'5px',verticalAlign:'middle'}} src={kmf_icon} alt="KMF" /><label style={{verticalAlign:'middle'}}>KMF</label></div>}
        ]   
    }

    const customStyles = {
        control: (provided) => ({
            ...provided,
            //minHeight: "50px",   // hauteur du select
            maxheight: "30px",
            padding: "0px",
            marginTop:'auto',
            marginBottom:'auto'
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: "20px",
            padding: "0px 0px 0px 10px",
            marginTop:'auto',
            marginBottom:'auto'
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: "25px",
            marginTop:'auto',
            marginBottom:'auto'
        })};

    const HandleLang=(value,action)=>{
        if(value.value!==lang)
        {
            setLang(value.value);
            i18n.changeLanguage(value.value);
            setAppState({...AppState,settings:{...AppState.settings,lang:value.value}});
            localStorage.setItem('settings',JSON.stringify({devise:AppState.settings.devise,lang:value.value}));
            close();
        }
    }
    
    const HandleDevise=(value,action)=>{
        if(value.value!==dev)
        {
            setDev(value.value);
            setAppState({...AppState,settings:{...AppState.settings,devise:value.value}});
            localStorage.setItem('settings',JSON.stringify({lang:AppState.settings.lang,devise:value.value}));
            close();
        }
    }

    useEffect(()=>{
        const _settings = localStorage.getItem('settings');
        if(!!_settings)        {
            const settings = JSON.parse(_settings);
            //setAppState({...AppState,settings:{...AppState.settings,devise:settings.devise,lang:settings.lang}});
            //console.log(settings);
            setLang(settings.lang);
            setDev(settings.devise);
        }
        
    },[])
    /*
    useEffect(()=>{
        settings = JSON.stringify({lang:lang,devise:dev});
        var settings = sessionStorage.setItem('settings',settings)
    },[lang,dev])
    */
    return(
            <div style={{}} id='settings-menu' onClick={e=>{e.stopPropagation();}}>
                <div style={{width:'100%',borderBottom:'1px solid lightgray',margin:'5px 10px 5px 10px',paddingBottom:'5px'}}>
                    <label>{t('navigation.langue')} : </label>
                    <div style={{display:'inline-block',width:'60%',marginLeft:'10px',verticalAlign:'middle'}}>
                        <Select menuPlacement='top' isSearchable={false} styles={customStyles} options={options.lang} value={options.lang.find(o => o.value === lang)} onChange={(value,action)=>{HandleLang(value,action)}} />
                    </div>
                </div>
                <div style={{width:'100%',borderBottom:'1px solid lightgray',margin:'5px 10px 5px 10px',paddingBottom:'5px'}}>
                    <label>{t('navigation.devise')} : </label>
                    <div style={{display:'inline-block',width:'60%',marginLeft:'10px',verticalAlign:'middle'}}>
                        <Select menuPlacement='top' isSearchable={false} styles={customStyles} options={options.devise} value={options.devise.find(o => o.value === dev)} onChange={(value,action)=>{HandleDevise(value,action)}} />
                    </div>
                </div>
            </div>
        )
}

function QRScanMenu({scanner,setScanner})
{
    const [UserState,setUserState] = useContext(UserContext);
    const {t} = useTranslation();

    return(
    
            <div style={{backgroundColor:'white',height:'fit-content',position:'absolute',bottom:'0px',width:'100%'}} onClick={e=>{e.stopPropagation();}}>
                <div style={{width:'100%',borderBottom:'1px solid lightgray',margin:'auto auto 5px auto'}}>
                    <button style={{width:'90%',height:'40px'}} onClick={e=>{setScanner({...scanner,display:'colis'})}}><label>{t('sales.colis')}</label> </button>
                </div>
                { (UserState.is_staff || UserState.is_partner ) &&
                <div style={{width:'100%',borderBottom:'1px solid lightgray',margin:'5px auto 5px auto'}}>
                    <button style={{width:'90%',height:'40px'}} onClick={e=>{setScanner({...scanner,display:'payments'})}}><label style={{verticalAlign:'middle'}}>{t('user-menu.paiements')}</label></button>
                </div>}
            </div>

    )
}

function Footer() {

    const [scanner,setScanner] = useState({display:'none',data:null});
    const [notification,setNotification] = useState({text:"",color:'black',display:'none'});
    const fetchData = useFetch();
    const [UserState,setUserState] = useContext(UserContext);
    const [user_role,setUserRole] = useState({is_staff:UserState.is_staff,is_partner:UserState.is_partner,is_deliver:false});
    const [FilterComponent,SetFilterComponent] = useState({
        display:false,
        componet: <div className='footer-pop-screen' style={{height:'100vh'}} onClick={()=>{console.log('OK');SetFilterComponent({...FilterComponent,display:false});}}>
                    <div style={{height:'100%',position:'absolute',bottom:'0px',right:'0px',width:'75%'}} onClick={e=>{e.stopPropagation();}}>
                        <Filtres close={()=>{SetFilterComponent({...FilterComponent,display:false});}} />
                    </div>  
                </div>
    });


    useEffect(()=>{
        setUserRole({is_staff:UserState.is_staff,is_partner:UserState.is_partner,is_deliver:UserState.is_deliver});
    },[UserState.is_staff,UserState.is_partner,UserState.is_deliver])

    const [settingsComponent,SetSettingsComponent] = useState({
        display:false,
        component:
        <div className='footer-pop-screen' style={{height:'100vh'}} onClick={()=>{SetSettingsComponent({...settingsComponent,display:false});}}>
            <SettingsMenu close={()=>{SetSettingsComponent({...settingsComponent,display:false});}} />
        </div> 
    });

    const [ScanMenu,SetScanMenu] = useState({
        display:false,
        component: 
        <div className='footer-pop-screen' style={{height:'100vh'}} onClick={()=>{SetScanMenu({...ScanMenu,display:false});}}>
            <QRScanMenu scanner={scanner} setScanner={setScanner} />
        </div>
    });
    

    const Btn_Payments = ()=>{
        if(user_role.is_staff || user_role.is_partner || user_role.is_deliver)
            return(
                <div className="btn-nav">
                    <img style={{width:'100%'}} onClick={e=>{/*setScanner({...scanner,display:'payments'})*/console.log(UserState);SetScanMenu({...ScanMenu,display:!ScanMenu.display})}}  src={money_icon}  alt="navigation"/>
                    {(UserState.global_payments_counter>0) && <span id="notif" onClick={e=>{}}>
                        {UserState.global_payments_counter}
                    </span>}
                </div>
            );
        else
            return(
        <div className="btn-nav">
            <Popup trigger={<img style={{width:'100%'}} onClick={e=>{}}  src={aboutIcon}  alt="navigation"/>}>
                {(close)=><div id="user-cond" style={{width:'100%',height:'50vh',textAlign:'left',marginTop:'15px'}}>
                    <div style={{textAlign:'center',height:'95%',border:'1px solid lightgray',fontSize:'x-small',backgroundColor:'whitesmoke',padding:'0px 10px 20px 20px',borderRadius:'10px',overflowY:'scroll'}}>
                        <CG close={close} />
                    </div>
                </div>}
            </Popup>
        </div>);
    }

    const Btn_Colis = ()=>{
        if(UserState.auth)
            return(
                <div className="btn-nav">
                    <img style={{width:'100%'}} onClick={e=>{setScanner({...scanner,display:'colis'})}}  src={colis_icon}  alt="navigation"/>
                </div>
            );
        else
            return(
            <div className="btn-nav">
                <img style={{width:'100%'}} onClick={e=>{SetSettingsComponent({...settingsComponent,display:!settingsComponent.display});}}  src={settingsIcon}  alt="navigation"/>
            </div>);
    }
    

  return (
    <div id='footer' style={{zIndex:999999}}>
        {/*<Btn_Colis />*/}
        <div className="btn-nav">
            <img style={{width:'100%'}} onClick={e=>{SetSettingsComponent({...settingsComponent,display:!settingsComponent.display});}}  src={lang_icon}  alt="navigation"/>
        </div>
        <ButtonConversations />
        <Btn_Payments />
        <Notifications />
        <div onClick={e=>{SetFilterComponent({...FilterComponent,display:!FilterComponent.display});}} className='btn-nav'>
            <img style={{width:'100%'}} src={filtresIcons}  alt="navigation"/>
        </div>
        {FilterComponent.display && FilterComponent.componet}
        {settingsComponent.display && settingsComponent.component}
        {ScanMenu.display && ScanMenu.component}
        {(scanner.display==='payments') && <ButtonQrPayment close={()=>{setScanner({...scanner,display:'none'})}} />}
        {(scanner.display==='colis') && <ButtonQrPackage close={()=>{setScanner({...scanner,display:'none'})}} />} 
    </div>
  )
}

export default Footer;
